var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": "960" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct(_vm.title)))]),
      _vm.currentTab == 0
        ? _c("app-total-edit-columns", {
            attrs: {
              browse: _vm.browse,
              value: _vm.value,
              "current-tab": _vm.currentTab,
              model: _vm.model,
            },
            on: {
              "update:currentTab": function ($event) {
                _vm.currentTab = $event
              },
              "update:current-tab": function ($event) {
                _vm.currentTab = $event
              },
            },
          })
        : _vm.currentTab == 1
        ? _c("app-total-edit-style", {
            attrs: { "current-tab": _vm.currentTab, value: _vm.value },
            on: {
              "update:currentTab": function ($event) {
                _vm.currentTab = $event
              },
              "update:current-tab": function ($event) {
                _vm.currentTab = $event
              },
            },
          })
        : _vm.currentTab == 2
        ? _c("app-total-edit-filters", {
            attrs: {
              browse: _vm.browse,
              "current-tab": _vm.currentTab,
              value: _vm.value,
              model: _vm.model,
            },
            on: {
              "update:currentTab": function ($event) {
                _vm.currentTab = $event
              },
              "update:current-tab": function ($event) {
                _vm.currentTab = $event
              },
            },
          })
        : _vm.currentTab == 3
        ? _c("app-total-edit-conditions", {
            attrs: { "current-tab": _vm.currentTab, value: _vm.value },
            on: {
              "update:currentTab": function ($event) {
                _vm.currentTab = $event
              },
              "update:current-tab": function ($event) {
                _vm.currentTab = $event
              },
            },
          })
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }